import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        defaultTheme: "light",
        themes: {
            light: {
                background: "#eee",
                surface: "#ffce67",
                primary: "#56cc9d",
                secondary: "#e9908c",
                error: "#ff8562",
            },
            dark: {
                background: "#15202b",
                surface: "#15202b",
                primary: "#3f51b5",
                secondary: "#03dac6",
                error: "#ff5722",
            },
        },
    },
});
